import {useEffect} from 'react'
import {toAbsoluteUrl} from 'helpers'

const AuthWrapper = ({children}) => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => document.body.classList.remove('bg-white')
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`}}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <span className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/main-logo.svg')} className='h-45px' />
        </span>
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>{children}</div>
      </div>
    </div>
  )
}

export default AuthWrapper
